$(document).ready(function() {
$('#animationImage').on('click', function() {
$('#lightbox-animation').css('display', 'block');
$('#lightbox-img').attr('src', this.src);
$('body').css('overflow', 'hidden');
});

$('.close').on('click', function() {
$('#lightbox-animation').css('display', 'none');
$('body').css('overflow', 'auto');
});

$(window).on('click', function(event) {
if (event.target.id === 'lightbox-animation') {
$('#lightbox-animation').css('display', 'none');
$('body').css('overflow', 'auto');
}
});
});

$(document).ready(function() {
$('#illustrationImage').on('click', function() {
$('#lightbox-illustration').css('display', 'block');
$('#lightbox-illustration-img').attr('src', this.src);
$('body').css('overflow', 'hidden');
});

$('.close').on('click', function() {
$('#lightbox-illustration').css('display', 'none');
$('body').css('overflow', 'auto');
});

$(window).on('click', function(event) {
if (event.target.id === 'lightbox-illustration') {
$('#lightbox-illustration').css('display', 'none');
$('body').css('overflow', 'auto');
}
});
});